var map = {
	"./cwfz5.svg": 9678,
	"./exit-fullscreen.svg": 871,
	"./eye-open.svg": 4301,
	"./eye.svg": 4986,
	"./fullscreen.svg": 6286,
	"./guide.svg": 5860,
	"./hamburger-closed.svg": 149,
	"./hamburger-opened.svg": 6929,
	"./language.svg": 9424,
	"./password.svg": 6408,
	"./user.svg": 42
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;